const rows = [
  { label: "会社名", value: "株式会社Wind" },
  { label: "所在地", value: "〒156-0043 東京都世田谷区松原3-30-10 双葉屋ビル 2F" },
  { label: "事業内容", value: "原状回復工事・内装リフォーム・ハウスクリーニング 他" },
  { label: "資本金", value: "5,000,000円" },
  { label: "営業時間", value: "9:00 〜 18:00(定休日:水曜日・日曜日・祝日)" },
  { label: "対応エリア", value: "東京都・神奈川県" },
];

export default function Company() {
  return (
    <section id="company" role="region" aria-label="会社概要" className="relative bg-background-100/60 py-20 md:py-32 px-6 md:px-16 lg:px-24">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="w-10 h-px bg-primary-500"></span>
            <span className="text-xs tracking-[0.3em] uppercase text-primary-700 font-medium">
              Company
            </span>
            <span className="w-10 h-px bg-primary-500"></span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            会社概要
          </h2>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden" itemScope itemType="https://schema.org/Organization">
          <meta itemProp="name" content="株式会社Wind" />
          <meta itemProp="foundingDate" content="2018" />
          {rows.map((r, i) => (
            <div
              key={r.label}
              className={`flex flex-col sm:flex-row gap-2 sm:gap-6 px-6 md:px-10 py-5 md:py-6 ${
                i !== rows.length - 1 ? "border-b border-background-200/70" : ""
              }`}
              {...(r.label === "会社名" ? { itemProp: "legalName" } : {})}
              {...(r.label === "所在地" ? { itemProp: "address", itemScope: true, itemType: "https://schema.org/PostalAddress" } : {})}
              {...(r.label === "営業時間" ? { itemProp: "openingHours" } : {})}
            >
              <div className="sm:w-40 shrink-0">
                <span className="text-xs tracking-[0.25em] uppercase text-primary-700 font-semibold">
                  {r.label}
                </span>
              </div>
              <div className="flex-1 text-foreground-900 text-sm md:text-base leading-relaxed">
                {r.value}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}